export default __webpack_public_path__ + "static/media/wh_ep2_wenny_surprised.d43cdf04.png";